export default "__VITE_ASSET__oJXXRRJA__"